import { render } from "./main-layout.vue?vue&type=template&id=1b66a69b&scoped=true&ts=true"
import script from "./main-layout.vue?vue&type=script&lang=ts"
export * from "./main-layout.vue?vue&type=script&lang=ts"

import "./main-layout.vue?vue&type=style&index=0&id=1b66a69b&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b66a69b"]])

export default __exports__